import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { ACCOUNTS_QUERY_KEY } from "./useAccounts";

export type DeleteAccountVariables = {
  accountId: string;
};

export function useDeleteAccount() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteAccountVariables>({
    mutationFn: async ({ accountId }) => {
      const { error } = await client.DELETE("/api/accounts/{account_id}", {
        params: { path: { account_id: accountId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to delete account ${accountId}`);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}
